<template>
  <section id="Galerie" class="py-5">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-5">
          <h2 class="my-5 text-center">Fotogalerie</h2>
          <p class="text-muted mb-5 text-center">Hier ein kleiner Auszug aus meinen Events</p>
          <div class="slider position-relative bg-light">
            <img class="slide" src="@/assets/img/galerie/1.jpg">
            <img class="slide" src="@/assets/img/galerie/2.jpg">
            <img class="slide" src="@/assets/img/galerie/3.jpg">
            <img class="slide" src="@/assets/img/galerie/4.jpg">
            <img class="slide" src="@/assets/img/galerie/5.jpg">
            <img class="slide" src="@/assets/img/galerie/6.jpg">
            <img class="slide" src="@/assets/img/galerie/7.jpg">
            <img class="slide" src="@/assets/img/galerie/8.jpg">
            <img class="slide" src="@/assets/img/galerie/9.jpg">
            <img class="slide" src="@/assets/img/galerie/10.jpg">
            <img class="slide" src="@/assets/img/galerie/11.jpg">
            <img class="slide" src="@/assets/img/galerie/12.jpg">
            <img class="slide" src="@/assets/img/galerie/13.jpg">
            <img class="slide" src="@/assets/img/galerie/14.jpg">
            <img class="slide" src="@/assets/img/galerie/15.jpg">
            <img class="slide" src="@/assets/img/galerie/16.jpg">
            <img class="slide" src="@/assets/img/galerie/17.jpg">
            <img class="slide" src="@/assets/img/galerie/18.jpg">
            <img class="slide" src="@/assets/img/galerie/19.jpg">
            <img class="slide" src="@/assets/img/galerie/20.jpg">
            <img class="slide" src="@/assets/img/galerie/21.jpg">
            <img class="slide" src="@/assets/img/galerie/22.jpg">
            <img class="slide" src="@/assets/img/galerie/23.jpg">
            <img class="slide" src="@/assets/img/galerie/24.jpg">
            <img class="slide" src="@/assets/img/galerie/25.jpg">
            <img class="slide" src="@/assets/img/galerie/26.jpg">
            <img class="slide" src="@/assets/img/galerie/27.jpg">
            <img class="slide" src="@/assets/img/galerie/28.jpg">
            <img class="slide" src="@/assets/img/galerie/29.jpg">

            <div @click="swipe('left')" class="swipe swipe-left">‹</div>
            <div @click="swipe('right')" class="swipe swipe-right">›</div>

            <small class="text-muted" id="count">{{ count }}</small>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {ref} from "vue";
const slides = document.getElementsByClassName('slide');
let sliderIndex = 0;
const count = ref('');

window.onload = function() {
  slides[sliderIndex].classList.add('visible-slide');
  count.value = 'Bild ' + (sliderIndex + 1) + '/' + slides.length;
}

setInterval(function() {
  swipe('right');
}, 6000)

const swipe = (direction) => {
  slides[sliderIndex].classList.remove('visible-slide');
  switch (direction) {
    case 'right':
      sliderIndex = (sliderIndex < slides.length - 1) ? sliderIndex + 1 : 0;
      break;
    case 'left':
      sliderIndex = (sliderIndex > 0) ? sliderIndex - 1 : slides.length - 1;
  }
  slides[sliderIndex].classList.add('visible-slide');
  count.value = 'Bild ' + (sliderIndex + 1) + '/' + slides.length;
}
</script>

<style scoped>
.slider {
  height: 80vh;
  width: 100%;
}
.slide {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  opacity: 0;
  transition: 1s;
}
.visible-slide {
  opacity: 1;
}
.swipe {
  position: absolute;
  font-size: 2.5rem;
  background: rgba(0, 0, 0, 0.55);
  transition: 0.5s;
  top: calc(50% - 40px);
  z-index: 1;
  color: white;
  cursor: pointer;
}
.swipe:hover {
  background: rgba(0, 0, 0, 0.75);
}
.swipe-left {
  padding: 20px 20px 30px 20px;
  border-radius: 0 20px 20px 0;
  left: 0;
}
.swipe-left:hover {
  padding: 20px 25px 30px 15px;
}
.swipe-right {
  padding: 20px 20px 30px 20px;
  border-radius: 20px 0 0 20px;
  right: 0;
}
.swipe-right:hover {
  padding: 20px 15px 30px 25px;
}
#count {
  padding: 5px 10px;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>